import { Tooltip } from "@mui/material";
import { StatusChip } from "components/StatusChip";

import {
  DOCUMENT_STATE_CHIP_COLOR,
  DOCUMENT_STATE_LABELS,
  DOCUMENT_STATE_TOOLTIP,
  DOCUMENT_STATE_TOOLTIP_STATIC,
  type DocumentState,
} from "./documentStateDisplay";

/**
 * The Document Review column cell: one chip per document state, with the
 * state explained on hover. Clicking opens the manifest drawer scrolled to
 * the Documents section (the caller supplies that navigation), so every
 * state's remediation — Process, re-upload, or first upload — is one click
 * away.
 */
export function DocumentReviewStatusCell({
  state,
  onClick,
}: {
  state: DocumentState;
  onClick?: () => void;
}) {
  return (
    <Tooltip title={onClick ? DOCUMENT_STATE_TOOLTIP[state] : DOCUMENT_STATE_TOOLTIP_STATIC[state]}>
      <StatusChip
        variant="outlined"
        color={DOCUMENT_STATE_CHIP_COLOR[state]}
        label={DOCUMENT_STATE_LABELS[state]}
        clickable={Boolean(onClick)}
        onClick={
          onClick
            ? (event) => {
                event.stopPropagation();
                onClick();
              }
            : undefined
        }
      />
    </Tooltip>
  );
}
